import { Slider } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekSlider = styled(Slider)(({ theme }) => ({
    "& .MuiSlider-thumb": {
        backgroundColor: theme.palette.secondary.main,
    },
}));

export { PeekSlider, PeekSlider as default };
